<template>
  <v-select
    v-bind="selectProps"
    variant="solo"
    density="compact"
    :model-value="modelValue"
    @update:model-value="onUpdateModelValue"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-select>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { VSelect } from 'vuetify/components';

export default defineComponent({
  name: 'UIVSelect',
  components: { VSelect },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number, Array, Object] as PropType<any>,
      default: undefined,
    },
    // Support deprecated Vuetify 2 prop
    itemText: {
      type: [String, Function] as PropType<string | ((item: any) => string)>,
      default: undefined,
    },
    // Vuetify 3 prop
    itemTitle: {
      type: [String, Function] as PropType<string | ((item: any) => string)>,
      default: undefined,
    },
    itemValue: {
      type: [String, Function] as PropType<string | ((item: any) => any)>,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    selectProps(): Record<string, any> {
      const props = { ...this.$attrs };

      // Map itemText to itemTitle if itemTitle is not provided
      if (this.itemText && !this.itemTitle) {
        props.itemTitle = this.itemText;
      } else if (this.itemTitle) {
        props.itemTitle = this.itemTitle;
      }

      if (this.itemValue) {
        props.itemValue = this.itemValue;
      }

      return props;
    },
  },
  methods: {
    onUpdateModelValue(value: any) {
      this.$emit('update:modelValue', value);
    },
  },
});
</script>
